module.exports = __webpack_public_path__ + "img/Italy.015f450e.png";